// the types aren't exactly accurate for this from the package...
type Navigation = {
  getState: () => {
    history?:
      | unknown[]
      | {
          index: number;
          routes: { name: string }[];
        };
  };
};

export function getLastRoute(navigation: Navigation) {
  const state = navigation.getState();

  if (
    state.history &&
    !Array.isArray(state.history) &&
    state.history.routes &&
    typeof state.history.index !== 'undefined'
  ) {
    const lastIdx = state.history.index - 1;
    return state.history.routes[lastIdx];
  }

  return undefined;
}
